import { echartLine } from '../common';

export function echartAnellLineMonth(vis, datos) {
  echartLine(
    datos,
    true,
    1,
    'ANELL CICLISTA: HISTÒRIC MENSUAL',
    'Bicicletes',
    'chartAnellLineMonth',
    'no_dataAnellLineMonth',
    undefined,
    true,
  );
}
export function echartAccesosLineMonth(vis, datos) {
  echartLine(
    datos,
    true,
    1,
    'ACCESSOS ANELL CICLISTA: HISTÒRIC MENSUAL',
    'Bicicletes',
    'chartAccessosAnellLineMonth',
    'no_dataAccessosAnellLineMonth',
    undefined,
    true,
  );
}
